'use client';

import { type RefObject, useEffect } from 'react';
import { type AmbientScrambleOptions, startAmbientScramble } from '@/lib/textEffects/scramble';

export function useAmbientScramble(rootRef: RefObject<HTMLElement | null>, options: AmbientScrambleOptions = {}): void {
  const { selector, concurrent } = options;

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    return startAmbientScramble(root, options);
  }, [rootRef, selector, concurrent]);
}
